
import { useLocation } from "react-router-dom";
import { TaskGet } from "../../../../shared/lib/types/Types";
import { useSelector } from "react-redux";
import { useAppSelector } from "../../../../shared/hooks/useReduxHooks";
import { matrixSlice } from "../../../matrix-task/model/matrix-task.slice";

export function useFocusInfo() {
    const seen = new Set<number>();
    const todos = useSelector((state: any) => state.todos.todos);
    const isMatrixActive = useAppSelector(matrixSlice.selectors.getIsOpenMatrix);
    const location = useLocation();        

    for (const t of todos) {
        if (t.priority === 0 || t.priority === 1 || t.priority === 2 || t.priority === 3) {
        seen.add(t.priority);
        }
    }

    const arrPriorities: number[] | null = seen.size > 0 ? [...seen].sort((a: number,b: number) => a - b) : null;
    
    
    function getCountTask(todos: TaskGet[]) {
        if (location && location.pathname !== '/') {
            return {
                isDisabled: true,
                description: 'Режим фокуса доступен только на \n странице Мой день',
                subDescription: null
            }
        }
        if (isMatrixActive) {
            return {
                isDisabled: true,
                description: 'Одновременно можно исспользовать только один режим. \n Чтобы переключиться, выйдите из текущего.',
                subDescription: null
            }
        }
        if (todos.length === 0) {
            return {
                isDisabled: true,
                description: 'Режим затемняет лишнее, подсвечивает приоритеты и ведёт по задачам шаг за шагом',
                subDescription: null
            }
        }
        if (arrPriorities && arrPriorities.length < 2) {
            return {
                isDisabled: true,
                description: 'Режим затемняет лишнее, подсвечивает приоритеты и ведёт по задачам шаг за шагом',
                subDescription: 'Добавь задачи с разными приоритетами, чтобы увидеть, как работает режим Фокус' 
            }
        }
        
        return {
            isDisabled: false,
            description: null,
            subDescription: null
        }
    }

    function getTasksWithoutTime(todos: TaskGet[]) {
        const counts = todos.reduce((acc, todo) => {
            const t = todo.time ?? null;
            if (t) return acc;
            const priority = todo.priority;
            acc[priority] = (acc[priority] ?? 0) + 1;
            return acc;
          }, {} as Record<number, number>);

        const resultWithoutTime = Object.entries(counts)
            .map(([priority, count]) => ({
                priority: Number(priority),
                count: Number(count),
            }))

        return resultWithoutTime
    }

    function getTasksWithTime(todos: TaskGet[]) {
        const groupByTime = todos.reduce((acc, todo) => {
            const t = todo.time ?? null;
            if (!t) return acc;
            const priority = todo.priority;
            acc[priority] ??= {};
            acc[priority][t] = (acc[priority][t] ?? 0) + 1;
            return acc
          }, {} as Record<number, Record<string, number>>);
        const toMinutes = (hhmm: string) => {
            const [h, m] = hhmm.split(":").map(Number);
            return h * 60 + m;
        };

        const resultByTime = Object.entries(groupByTime)
            .map(([priority, counts]) => ({
                priority,
                times: Object.entries(counts)
                .map(([time, keyCount]) => ({ time, keyCount: Number(keyCount) }))
                .sort((a, b) => toMinutes(a.time) - toMinutes(b.time)), 
            }))
            .sort((a, b) => toMinutes(a.times[0].time) - toMinutes(b.times[0].time));

        return resultByTime
    }
    let withTime = getTasksWithTime(todos);
    let withOutTime = getTasksWithoutTime(todos);
    let getTooltipData = getCountTask(todos);
    let priorityCount = arrPriorities;

    return { withTime, withOutTime, getTooltipData, priorityCount }
}
